import React from 'react';
import classes from "./SmallLoader.module.css";

const SmallLoader = () => {
  return (
    <span className={classes.loader} ></span>
  )
}

export default SmallLoader